import {dataLayerComposeProduct, dataLayerPush} from '@/utils/dataLayerHelper';
import {createUUID} from '@/utils/uuid';
import type {Product} from '@/types/product';
import type {BasketBlock} from '@/types/basket';

if (typeof window.composeOrderDecoratorJson !== 'undefined' && window.composeOrderDecoratorJson.basket) {

	const orderStreetStep = window.orderStreetStep;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const initialBasketEvent: { [key: string]: any } = {
		event: 'checkout',
		ecommerce: {
			checkout: {
				actionField: {
					step: orderStreetStep
				},
				products: []
			}
		}
	};

	if (window.composeOrderDecoratorJson.basket.mainProduct) {
		initialBasketEvent.ecommerce.checkout.products.push(dataLayerComposeProduct(window.composeOrderDecoratorJson.basket.mainProduct));
	}

	if (window.composeOrderDecoratorJson.basket.orderedProductsMonthly) {
		window.composeOrderDecoratorJson.basket.orderedProductsMonthly.forEach((basketBlock: BasketBlock) => {
			basketBlock.products.forEach((product: Product) => {
				initialBasketEvent.ecommerce.checkout.products.push(dataLayerComposeProduct(product));
			});
		});
	}

	/**
	 * initialBasketEvent aanpassen voor de 'bedankt' pagina na een succesvolle bestelling
	 */
	if (orderStreetStep === 4) {
		initialBasketEvent.event = 'purchase';
		initialBasketEvent.ecommerce.purchase = initialBasketEvent.ecommerce.checkout;

		const monthlyCosts = window.composeOrderDecoratorJson.basket.totalMonthlyCosts;
		const totalPrice = monthlyCosts[monthlyCosts.length - 1].totalPrice;
		const tax = totalPrice ? (totalPrice * (21 / 121)) : 0;

		delete initialBasketEvent.ecommerce.checkout;

		initialBasketEvent.ecommerce.purchase.actionField = {
			id: 'expansie.' + createUUID(),
			revenue: totalPrice,
			tax: tax.toFixed(2),
			shipping: '0.00',
			coupon: '',
			dimension5: window.composeOrderDecoratorJson.areaId,
			dimension9: 'Expansie'
		};
	}

	dataLayerPush(initialBasketEvent);
}

// perform dataLayerPush when available
if (window.dataLayerPushEvent) {
	dataLayerPush(window.dataLayerPushEvent);
}
